import { Stack, Typography } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import StepperDUC from "../StepperDUC";
import {
    stepLabels,
    stepLabelsDeclinedCommittee,
    stepLabelsDeclinedOfficial,
    stepLabelsDeclinedRecipient
} from "../DUCpage";
import React, { useState } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useUserInfoQuery } from "../../../api/userApiSlice";
import { useGetDUCInfoQuery } from "../../../api/ducApiSlice";

interface props {
    ducData: any
    declined: boolean
    expired: boolean
    activeStep: number
    index: number
}


const generateStepSummary = (props: props, ducDataObject: any) => {
    return (<Stack flexDirection="row" gap={3}>
        <Stack>
            <Stack
                flexDirection="column">
                <Typography variant="caption">
                    Submission date
                </Typography>
                <Typography>
                    {props.ducData?.dateSubmitted}
                </Typography>
            </Stack>
            <Stack
                flexDirection="column">
                <Typography variant="caption">
                    Expiration date
                </Typography>
                <Typography>
                    {props.ducData?.expiresOn}
                </Typography>
            </Stack>
            <Stack
                flexDirection="column">
                <Typography variant="caption">
                    Training Completed
                </Typography>
                <Typography>
                    {ducDataObject?.dateTrainingComplete || "Not complete yet"}
                </Typography>
            </Stack>
        </Stack>
        <Stack>
            <Stack
                flexDirection="column">
                <Typography variant="caption">
                    Authorized Institutional Business official email
                </Typography>
                <Typography>
                    {props.ducData?.signingAuthorityEmail}
                </Typography>
            </Stack>
            <Stack
                flexDirection="column">
                <Typography variant="caption">
                    Approval by official
                </Typography>
                <Typography>
                    {props.ducData?.dateSignedOfficial || "Not signed yet"}
                </Typography>
            </Stack>
        </Stack>
        <Stack>
            <Stack
                flexDirection="column">
                <Typography variant="caption">
                    NBDC Data Access committee email
                </Typography>
                <Typography>
                    {props.ducData?.committeeEmail}
                </Typography>
            </Stack>
            <Stack
                flexDirection="column">
                <Typography variant="caption">
                    Approval by committee
                </Typography>
                <Typography>
                    {props.ducData?.dateSignedCommittee || "Not signed yet"}
                </Typography>
            </Stack>
        </Stack>
    </Stack>);

}


const GeneralBlockStepper = (props: props) => {
    const { data: userData } = useUserInfoQuery({});
    const { data: ducDataObject } = useGetDUCInfoQuery({ email: userData?.email });

    const [hide, setHide] = useState(false)

    const handleClick = () => {
        setHide(!hide);
    }

    return (

        <Stack>
            <Stack flexDirection="row" onClick={handleClick}
                sx={{ "&:hover": {
                    cursor: "pointer" } }}>
                {hide && <PlayArrowIcon/>}
                {!hide && <ArrowDropDownIcon fontSize="large"/>}
                <Typography fontSize="16px" fontWeight="400">
                    Application
                </Typography>
            </Stack>

            { (props.ducData?.status  === 'Approved' || props.ducData?.status  === 'DucExpired' ||  props.ducData?.status  === 'TrainingExpired') && !hide && generateStepSummary(props, ducDataObject)}

            {props.ducData?.status !== 'Approved'  && !props.ducData?.declinedBy && !props.declined && !props.expired && !hide &&
                <StepperDUC
                    declined = {props.declined}
                    activeStep={props.activeStep}
                    stepLabels={stepLabels} />}

            {(props.ducData?.status  !== 'Approved' && props.ducData?.status  !== 'DucExpired') && props.ducData?.declinedBy === "Official" && !hide &&
                <StepperDUC
                    declined = {props.declined}
                    activeStep={props.activeStep}
                    stepLabels={stepLabelsDeclinedOfficial} />}

            {(props.ducData?.status  !== 'Approved' && props.ducData?.status  !== 'DucExpired')&& props.ducData?.declinedBy === "Committee" && !hide &&
                <StepperDUC
                    declined = {props.declined}
                    activeStep={props.activeStep}
                    stepLabels={stepLabelsDeclinedCommittee} />}

            {(props.ducData?.status  !== 'Approved' && props.ducData?.status  !== 'DucExpired') && props.ducData?.declinedBy === "Submitter" && !hide &&
                <StepperDUC
                    declined = {props.declined}
                    activeStep={props.activeStep}
                    stepLabels={stepLabelsDeclinedRecipient} />}

            {props.ducData?.status  !== 'Approved' && props.ducData?.declinedBy === "EnvelopeExpiry" && !hide &&
                <StepperDUC
                    declined = {props.declined}
                    activeStep={props.activeStep}
                    stepLabels={stepLabels} />}


        </Stack>
    )

}

export default GeneralBlockStepper
